import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { fetchCustomers } from "../slices/customerSlice";

export const useCustomers = () => {
    const dispatch = useAppDispatch();
    const { customers, loading, error, success, hasFetched } = useAppSelector((state) => state.customers);

    useEffect(() => {
        if (!hasFetched) {
            dispatch(fetchCustomers());
        }
    }, [dispatch, hasFetched]);

  return { customers, loading, error, success, hasFetched };
};